export default __webpack_public_path__ + "static/media/roadmap.8c71037c.png";